import { OpenAPI } from "simplydo/interfaces";

type GenerateFileUploadRequest = OpenAPI.GET<'/uploads/file/request'>;
type GenerateMultiFileUploadRequest = OpenAPI.POST<'/uploads/file/request/multiple'>;

export const uploads = api => ({
  generateFileUploadRequest(
    {
      forType, forId, name, size, type,
    }: GenerateFileUploadRequest['parameters']['query'],
    success: (res: GenerateFileUploadRequest['response']) => void,
    fail,
  ) {
    api.maybeAuthenticatedRequest('GET', `/uploads/file/request?name=${encodeURIComponent(name)}&size=${size}&type=${type}&forType=${forType}&forId=${forId}`, null, success, fail);
  },
  generateMultiFileUploadRequest(
    files: GenerateMultiFileUploadRequest['requestBody']['files'],
    success: (res: GenerateMultiFileUploadRequest['response']) => void,
    fail,
  ) {
    api.maybeAuthenticatedRequest('POST', '/uploads/file/request/multiple', { files }, success, fail);
  },
  generateVideoUploadRequest({
    forType, forId, name, size, type,
  }, success, fail) {
    api.maybeAuthenticatedRequest('GET', `/uploads/video/request?name=${name}&size=${size}&type=${type}&forType=${forType}&forId=${forId}`, null, success, fail);
  },
  transcodeVideo(data, success, fail) {
    api.authenticatedRequest('POST', '/uploads/video/transcode', data, success, fail);
  },
  checkVideoTranscoded(type, id, fileName, success, fail) {
    api.unauthenticatedRequest('GET', `/uploads/video/check/${type}/${id}/${fileName}`, null, success, fail);
  },
  oneDriveListDirectory(path, success, fail) {
    api.authenticatedRequest('GET', `/uploads/onedrive/directory?path=${path}`, null, success, fail);
  },
  storeOneDriveFileInS3(itemId, itemName, forId, forType, success, fail) {
    api.authenticatedRequest('PUT', `/uploads/onedrive/store?itemId=${itemId}&itemName=${itemName}&forId=${forId}&forType=${forType}`, null, success, fail);
  },
});
